export const getDuration = (duration, conversation_created_at, messages, updated_at) => {
    /*
    if (messages.length == 0 || conversation_created_at == null) return "0s";
    let firstMsg = new Date(conversation_created_at)
    let updatedAt = new Date(updated_at);
    var diffMs = updatedAt - firstMsg;
    if (diffMs > 3600000) {
        diffMs = diffMs - 3600000
    }
    */
    //var totalSeconds = Math.floor(duration / 1000);
    
    const minutes = Math.floor(duration / 60);
    const seconds = Math.round(duration % 60);

    let val = minutes ? `${minutes}min` : '';
    return val += seconds + "s";

}

export const getMessagesDuration = (conversation_created_at, messages, updated_at) => {

    if (messages.length == 0 || conversation_created_at == null) return "0s";
    let firstMsg = new Date(conversation_created_at)
    //let lastMsg = new Date(messages[messages.length - 1].created_at.split('.')[0])
    let lastMsg = new Date(messages[messages.length - 1].created_at.split('.')[0].replace(' ', 'T') + 'Z');

    let updatedAt = new Date(updated_at);
    if (updatedAt - lastMsg <= 45000 && updatedAt >= lastMsg) {
        lastMsg = updatedAt;
    }
    var diffMs = lastMsg - firstMsg;
    if (diffMs > 3600000) {
        diffMs = diffMs - 3600000
    }
    var totalSeconds = Math.floor(diffMs / 1000);

    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    let val = minutes ? `${minutes}min` : '';
    return val += seconds + "s";
}

export default getDuration